/**
 * Auth session helpers for axios 401 / refresh handling.
 */

export function extractBearerToken(authorizationHeader) {
  if (!authorizationHeader) return null;
  const raw = String(authorizationHeader);
  const match = raw.match(/^Bearer\s+(.+)$/i);
  return match ? match[1] : raw;
}

/**
 * True when a failed request should clear the local session.
 * Prevents an in-flight 401 from an older token from wiping a fresh login.
 */
export function shouldClearSessionOnAuthFailure({
  failedAccessToken = null,
  currentAccessToken = null,
} = {}) {
  if (!currentAccessToken) return true;
  if (!failedAccessToken) return false;
  return failedAccessToken === currentAccessToken;
}

export function isAuthExemptRequestUrl(url = '') {
  const path = String(url);
  return (
    path.includes('/auth/login') ||
    path.includes('/auth/registration') ||
    path.includes('/auth/google') ||
    path.includes('/auth/password-reset') ||
    path.includes('/token/refresh') ||
    path.includes('/token/')
  );
}

export const AUTH_CLEARED_EVENT = 'yona:auth-cleared';
